import React, { useState, useMemo } from "react";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import cloneDeep from "lodash.clonedeep";
import {
    ControlLabel,
    FormControl,
    FormGroup,
    Checkbox,
    Button,
    Panel,
    Glyphicon,
    ListGroupItem,
} from "react-bootstrap";
import {
    EMOJI_LIST_BY_CATEGORIES,
    KEYWORDS_MAP_BY_CATEGORIES,
    MESSAGE_EMOJI_SRC
} from "../../../../../../platform/src/constants/components/emoji";
import { useModuleSettingsContext } from "../../../../../context";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import EmojiList from "./EmojiList";

import './styles.scss';

const MAX_QUANTITY_REACTIONS = 7;
const MIN_QUANTITY_REACTIONS = 1;

const Reactions = () => {
    const {
        moduleMain,
        onSaveMain,
        setPropertyMain,
        isSaving,
    } = useModuleSettingsContext();
    const [searchValue, setSearchValue] = useState('');

    const reactions = moduleMain.allowedReactions;

    const handleDeleteReaction = (reaction) => {
        onSaveMain({allowedReactions: moduleMain.allowedReactions.filter(item => item !== reaction)});
    }

    const handleSelectReaction = (reaction) => {
        if (moduleMain.allowedReactions?.length >= MAX_QUANTITY_REACTIONS) {
            return;
        }

        onSaveMain({allowedReactions: [...moduleMain.allowedReactions, reaction]});
    }

    const filteredEmoji = useMemo(() => {
        return Object.entries(KEYWORDS_MAP_BY_CATEGORIES).reduce((obj, category) => {
            const [key, values] = category;
            let result = [];

            Object.entries(values).forEach(([key, value]) => {
                if (key.toLowerCase().includes(searchValue.toLowerCase()) || !searchValue) {
                    result.push(value);
                }
            });

            obj[key] = [...new Set(result.flat())];

            return obj;
        }, {});
    }, [searchValue]);

    const handleDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }

        let _reactions = cloneDeep(reactions);
        const _reactionsCopy = cloneDeep(reactions);
        const [removed] = _reactions.splice(result.source.index, 1);
        _reactions.splice(result.destination.index, 0, removed);

        setPropertyMain('allowedReactions', _reactions);

        try {
            await onSaveMain({allowedReactions: _reactions});
        } catch (e) {
            console.error(e);
            setPropertyMain('allowedReactions', _reactionsCopy);
        }
    }

    return (
        <Panel style={{ flex: 1 }}>
            <PanelHeading>
                <PanelTitle>Реакции</PanelTitle>
            </PanelHeading>
            <PanelBody>
                <FormGroup>
                    <Checkbox
                        checked={moduleMain.showReaction}
                        onChange={(e) => onSaveMain({showReaction: e.target.checked})}
                    >Включить Реакции в плеере</Checkbox>
                </FormGroup>
                {moduleMain.showReaction && (
                    <>
                        <FormGroup>
                            <ControlLabel>Реакции в плеере (от {MIN_QUANTITY_REACTIONS} до {MAX_QUANTITY_REACTIONS})</ControlLabel>
                            <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="droppable" direction="horizontal">
                                    {(provided) => (
                                        <div
                                            className="reactions"
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {reactions?.map((reaction, index) => (
                                                <Draggable key={reaction} draggableId={reaction} index={index}>
                                                    {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <ListGroupItem
                                                                className="reactions--item"
                                                            >
                                                                <img src={MESSAGE_EMOJI_SRC(reaction)} alt="" />
                                                                <Button disabled={isSaving} className="reactions--item--remove" bsStyle="danger" onClick={() => handleDeleteReaction(reaction)}>
                                                                    <Glyphicon glyph="trash" />
                                                                </Button>
                                                            </ListGroupItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Список доступных реакций</ControlLabel>
                            <div className="reactions--block">
                                <FormControl
                                    name="search"
                                    type="text"
                                    required
                                    value={searchValue}
                                    placeholder="Поиск"
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                                <div className="reactions--emoji-picker">
                                    <EmojiList
                                        disabled={isSaving}
                                        emojiList={EMOJI_LIST_BY_CATEGORIES}
                                        filteredEmoji={filteredEmoji}
                                        onSelectEmoji={handleSelectReaction}
                                        onRemoveEmoji={handleDeleteReaction}
                                        activeReactions={moduleMain.allowedReactions || []}
                                    />
                                </div>
                            </div>
                        </FormGroup>
                    </>
                )}
            </PanelBody>
        </Panel>
    );
};

export default Reactions;